import './referral-terms.scss';

function ReferralTerms() {
  return (
    <div className="referral-terms-section">
      <h3 className="referral-terms-title">
        Referral Program Terms and Conditions
      </h3>

      <div className="referral-terms-content">
        <p className="terms-paragraph">
          By submitting a referral through this program, you confirm that you
          have the consent of the person you are referring to share their email
          address with Promotion Wingman. You understand and agree that an email
          will be sent to the referred individual, and that this message will
          include your name and email address as the referrer. This ensures
          transparency and prevents anonymous or unwanted referrals.
        </p>

        <p className="terms-paragraph">
          Each referred individual is eligible to receive a one-time 10%
          discount on their first subscription, provided they are not an
          existing or former subscriber. A referred person may only be referred
          once. To help maintain the integrity of our program and protect our
          users from spam, each referrer is limited to two (2) referrals per
          day.
        </p>

        <p className="terms-paragraph">
          As the referring party, you will be automatically entered into our
          giveaway drawing <strong>only if</strong> your referral results in a
          new paid subscription. Entry into the giveaway does not guarantee any
          prize or benefit and is subject to the official giveaway rules.
        </p>

        <p className="terms-paragraph">
          Misuse of the referral system, including but not limited to referring
          individuals without consent or attempting to bypass system limits, may
          result in disqualification from the referral program and forfeiture of
          any earned entries.
        </p>
      </div>
    </div>
  );
}

export default ReferralTerms;
